/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

export default function slateutil() {
	
	slate.utils = {

		/**
		 * Return an object from an array of objects that matches the provided key and value
		 *
		 * @param {array} array - Array of objects
		 * @param {string} key - Key to match the value against
		 * @param {string} value - Value to get match of
		 */
		findInstance: function(array, key, value) {
			for (var i = 0; i < array.length; i++) {
				if (array[i][key] === value) {
					return array[i];
				}
			}
		},

		/**
		 * Remove an object from an array of objects by matching the provided key and value
		 *
		 * @param {array} array - Array of objects
		 * @param {string} key - Key to match the value against
		 * @param {string} value - Value to get match of
		 */
		removeInstance: function(array, key, value) {
			var i = array.length;
			while(i--) {
				if (array[i][key] === value) {
					array.splice(i, 1);
					break;
				}
			}

			return array;
		},

		/**
		 * _.compact from lodash
		 * Remove empty/false items from array
		 * Source: https://github.com/lodash/lodash/blob/master/compact.js
		 *
		 * @param {array} array
		 */
		compact: function(array) {
			var index = -1;
			var length = array == null ? 0 : array.length;
			var resIndex = 0;
			var result = [];

			while (++index < length) {
				var value = array[index];
				if (value) {
					result[resIndex++] = value;
				}
			}
			return result;
		},

		/**
		 * _.defaultTo from lodash
		 * Checks `value` to determine whether a default value should be returned in
		 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
		 * or `undefined`.
		 * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
		 *
		 * @param {*} value - Value to check
		 * @param {*} defaultValue - Default value
		 * @returns {*} - Returns the resolved value
		 */
		defaultTo: function(value, defaultValue) {
			return (value == null || value !== value) ? defaultValue : value
		}
	};
}